import { useEffect, useRef } from "react";
import lottie from "lottie-web";

const LottieAnimation = ({ path, assetsPath, className = "" }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const abortController = new AbortController();
    let animation;

    const loadAnimation = async () => {
      try {
        const response = await fetch(path, { signal: abortController.signal });
        if (!response.ok) {
          throw new Error(`Failed to load animation (${response.status}): ${path}`);
        }

        const animationData = await response.json();
        if (assetsPath) {
          animationData.assets.forEach((asset) => {
            if (asset.p && !asset.p.startsWith("data:")) {
              asset.p = `${assetsPath}${asset.p}`;
            }
          });
        }

        if (!abortController.signal.aborted) {
          animation = lottie.loadAnimation({
            container,
            renderer: "svg",
            loop: true,
            autoplay: true,
            animationData,
            assetsPath,
          });
        }
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error(error);
        }
      }
    };

    loadAnimation();

    return () => {
      abortController.abort();
      animation?.destroy();
    };
  }, [path, assetsPath]);

  return <div ref={containerRef} className={className} aria-hidden="true" />;
};

export default LottieAnimation;
